export const NoResultsFound = () => (
  <div className="flex p-4">
    <span className="w-full text-[14px]/[20px] text-base-800 text-center">
      No results found
    </span>
  </div>
);
